import get from 'platform/utilities/data/get';
import {
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { standardTitle } from '../content/form0781';
import {
  evidenceRequestQuestion,
  ConfirmationEvidenceRequest,
} from '../content/evidenceRequest';
import {
  deriveMedicalRecordsFromLegacyData,
  isMedicalRecordsAnswered,
} from '../utils';

/**
 * Map legacy view:hasEvidence + view:selectableEvidenceTypes to
 * view:hasMedicalRecords for IPFs entering the enhanced flow, via the shared
 * deriveMedicalRecordsFromLegacyData algorithm (see utils/index.jsx). Only
 * runs when view:hasMedicalRecords is absent; leaves it absent when there
 * isn't enough legacy data to safely infer an answer.
 */
export const updateFormData = (oldFormData, formData) => {
  if (get('view:hasMedicalRecords', formData) !== undefined) {
    return formData;
  }

  const derived = deriveMedicalRecordsFromLegacyData(formData);
  if (derived === undefined) {
    return formData;
  }

  return { ...formData, 'view:hasMedicalRecords': derived };
};

export const uiSchema = {
  'ui:title': standardTitle(
    'Medical records that support your disability claim',
  ),
  // Legacy IPFs that answered this question under the old flow, then resumed
  // past this page after the enhancement toggle turned on, may never have
  // `view:hasMedicalRecords` set even though it's derivable. Don't block full
  // form validation on the raw field's presence in that case — but still
  // require an answer when the legacy data is too ambiguous to derive from.
  'ui:options': {
    updateSchema: formData => ({
      required: isMedicalRecordsAnswered(formData)
        ? []
        : ['view:hasMedicalRecords'],
    }),
  },
  'view:hasMedicalRecords': yesNoUI({
    title: evidenceRequestQuestion.label,
    hint: evidenceRequestQuestion.hint,
  }),
  'ui:confirmationField': ConfirmationEvidenceRequest,
};

export const schema = {
  type: 'object',
  required: ['view:hasMedicalRecords'],
  properties: {
    'view:hasMedicalRecords': yesNoSchema,
  },
};
